import React from "react";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import { editorialImageSrcSet } from "../utils/images";
import "../css/editorial-pages.scss";
import CommercialInquiryForm from "./CommercialInquiryForm";
import PageMeta from "./PageMeta";
import ProductCard from "./ProductCard";

const wholesaleProductIds = [1, 7, 11];

function Wholesale() {
  const wholesaleProducts = wholesaleProductIds
    .map((id) => productData.find((product) => product.id === id))
    .filter(Boolean);

  return (
    <main className="content-page editorial-page commercial-page wholesale-page">
      <PageMeta
        title="Wholesale pantry partnership"
        description={`Wholesale Italian pantry staples for thoughtful retailers and hospitality partners from ${siteConfig.brandName}.`}
      />

      <header className="commercial-hero commercial-hero--wholesale">
        <div className="page-shell commercial-hero__grid">
          <div className="commercial-hero__copy">
            <p className="eyebrow">Wholesale</p>
            <h1>Good shelves begin with good stories.</h1>
            <p>
              A focused Italian pantry for specialty retailers, restaurants,
              and hospitality teams that care about flavor and provenance.
            </p>
            <a className="button button--primary" href="#wholesale-application">
              Preview an application
            </a>
          </div>
          <div className="commercial-hero__media">
            <img
              src="/main/wholesale-pantry.jpg"
              srcSet={editorialImageSrcSet("/main/wholesale-pantry.jpg")}
              sizes="(max-width: 760px) 100vw, 50vw"
              alt="Two pantry workers arranging unbranded jars and cartons in a bright storeroom"
              width="1536"
              height="1024"
              loading="eager"
            />
            <p>Independent makers · clear provenance · practical support</p>
          </div>
        </div>
      </header>

      <section className="page-section page-shell" aria-labelledby="wholesale-fit-title">
        <div className="section-heading commercial-heading">
          <p className="eyebrow">Made for thoughtful trade partners</p>
          <h2 id="wholesale-fit-title">A small catalog with a strong point of view</h2>
          <p>
            The assortment is designed for businesses that want ingredients
            their staff can explain and their customers will come back for.
          </p>
        </div>
        <div className="commercial-service-grid commercial-service-grid--three">
          <article>
            <span>Retail</span>
            <h3>Specialty food shops</h3>
            <p>A coherent shelf of everyday staples, gifting favorites, and conversation starters.</p>
          </article>
          <article>
            <span>Hospitality</span>
            <h3>Restaurants and hotels</h3>
            <p>Distinctive pantry ingredients for service, rooms, welcome gifts, and small markets.</p>
          </article>
          <article>
            <span>Workplace</span>
            <h3>Corporate pantries</h3>
            <p>Better coffee-break and hosting staples for teams that gather around food.</p>
          </article>
        </div>
      </section>

      <section className="page-section commercial-products" aria-labelledby="wholesale-products-title">
        <div className="page-shell">
          <div className="commercial-products__header">
            <div className="section-heading">
              <p className="eyebrow">Shelf anchors</p>
              <h2 id="wholesale-products-title">Ingredients customers understand</h2>
            </div>
          </div>
          <div className="commercial-product-grid">
            {wholesaleProducts.map((product) => (
              <ProductCard product={product} key={product.id} tone="paper" />
            ))}
          </div>
        </div>
      </section>

      <section className="page-section page-shell commercial-process" aria-labelledby="wholesale-process-title">
        <div className="section-heading">
          <p className="eyebrow">Partnership process</p>
          <h2 id="wholesale-process-title">Built around fit, not volume alone</h2>
        </div>
        <ol>
          <li><strong>Introduce the business.</strong><span>Share your format, location, audience, and the shelf you want to build.</span></li>
          <li><strong>Review the assortment.</strong><span>A future trade team can discuss case packs, availability, lead times, and product education.</span></li>
          <li><strong>Plan a first order.</strong><span>Choose a focused opening mix, then learn from what your customers reach for.</span></li>
        </ol>
      </section>

      <section
        className="commercial-inquiry commercial-inquiry--wholesale"
        id="wholesale-application"
        aria-labelledby="wholesale-application-title"
      >
        <div className="page-shell commercial-inquiry__grid">
          <div className="commercial-inquiry__intro">
            <p className="eyebrow">Trade application</p>
            <h2 id="wholesale-application-title">Start with a proper introduction.</h2>
            <p>
              This is a browser-only application preview. It collects nothing
              until a secure business workflow is connected.
            </p>
          </div>
          <CommercialInquiryForm type="wholesale" />
        </div>
      </section>
    </main>
  );
}

export default Wholesale;
